import { RoomEvent, Room, RoomMember } from 'matrix-js-sdk';
import { Log } from '@fanfanlo';
import { roomService } from '../roomService';
import { matrixClient } from '../../client';
import { IMatrixRoomInfo } from '../types';

const logger = new Log(false, 'im.client.room.handlers.membership');
logger.childrenPaused = true;
function onMyMembershipChanged(room: Room, membership: string, prevMembership?: string) {
    const roomId = room.roomId;
    logger.log(`Membership changed in room ${room.name} (${roomId}): ${prevMembership} -> ${membership}`);

    const client = matrixClient.client;
    const avatarUrl = room.getAvatarUrl(client.getHomeserverUrl(), 32, 32, 'scale', false, false) || undefined;
    
    const roomInfo: IMatrixRoomInfo = {
        roomId,
        name: room.name,
        membership: membership as any,
        avatarUrl
    };

    if (membership === 'join') {
        roomService.addJoinedRoom(roomId);
    } else if (membership === 'leave' || membership === 'ban') {
        roomService.removeJoinedRoom(roomId);
    }

    roomService.addOrUpdateRoomInfo(roomInfo);
}

export const membershipHandler = {
    init() {
        matrixClient.clientOnEventDispatcher.addListener(RoomEvent.MyMembership, onMyMembershipChanged);
    }
};
